export default __webpack_public_path__ + "static/media/arrow2.f8535f96.png";